import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";

const Mediaplayer = ({ frame }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { defaultPlayer }
      }
    }) => {
      const data = {
        frame: frame || defaultPlayer
      };

      return <div dangerouslySetInnerHTML={{ __html: data.frame }} />;
    }}
  />
);

Mediaplayer.propTypes = {
  frame: PropTypes.string
};

Mediaplayer.defaultProps = {
  frame: null
};

export default Mediaplayer;

const query = graphql`
  query Mediaplayer {
    site {
      siteMetadata {
        defaultPlayer
      }
    }
  }
`;
